
























































import BaseComponent from '@/components/base-component.vue';
import ParametersEditModal from '@/components/parameters/edit-modal.vue';
import ReasonForm from '@/components/parameters/indexacao-template/form.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiReferencesTypesHierarchy from '@/components/UI/references-types-hierarchy/index.vue';
import UiToggleStatus from '@/components/UI/toggle-status.vue';
import ParameterModel from '@/models/parameter-model';
import { PARAMETER_TYPE_TEXT } from '@/settings/consts/parameters-keys';
import { cloneDeep } from 'lodash';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    UiReferencesTypesHierarchy,
    ListMessages,
    UiToggleStatus,
    ReasonForm,
    PermissionAuth,
    ParametersEditModal,
  },
})
export default class ParametersFormIndexacaoTemplate extends BaseComponent {
  @Prop()
  public editItem: any;
  @Prop()
  public modalOpen: boolean;

  public form: any = {
    valid: false,
    rules: {
      clientUnit: [(v) => !!v || 'Selecione uma Unidade'],
      team: [(v) => !!v || 'Selecione um Time'],
      doctor: [(v) => !!v || 'Selecione um Médico'],
    },
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  public formIsEdit: boolean = false;
  public formOpen: boolean = false;
  public error: boolean = false;
  public loading: boolean = false;

  public headers: any = [
    { text: 'Descrição', value: 'valor' },
    { text: 'Ações', value: 'actions', sortable: false, align: 'right' },
  ];
  public data: ParameterModel = new ParameterModel();
  public item: any = {};

  @Watch('editItem')
  public onEditItemChanges(val): void {
    this.data = new ParameterModel(val);
  }

  public beforeMount(): void {
    this.onEditItemChanges(this.editItem);
  }

  public onEditItem(item: any): void {
    this.item = cloneDeep(item);
    this.formOpen = true;
    this.formIsEdit = true;
  }

  public onDeleteItem(item: any): void {
    const deleteItem = () => {
      this.loader.start('Deletando registro...');
      const index = this.data.valores.findIndex((el) => el === item);
      if (index !== -1) {
        const values = cloneDeep(this.data.valores);
        values.splice(index, 1);
        this.data.valores = values;
        this.loader.stop();
      } else {
        this.loader.stop();
        this.toast.show('Ocorreu um erro ao excluir o registro', 'error');
      }
    };

    this.dialog.show(
      'error',
      'Excluir Motivo',
      'Tem certeza que deseja excluir este motivo?',
      'Cancelar',
      '',
      'Excluir',
      deleteItem,
    );
  }

  public saveItemValue(item): void {
    this.loader.start('Salvando registro...');

    if (!item.id) {
      const uuidv4 = require('uuid/v4');
      item.id = uuidv4();
      item.nome = item.valor;
      item.tipoValorParametro = PARAMETER_TYPE_TEXT;
      item.isNew = true;
      item.ativo = true;
      this.data.valores.push(item);
    } else {
      const index = this.data.valores.findIndex((el) => el.id === item.id);
      item.nome = item.valor;
      const values = cloneDeep(this.data.valores);
      values.splice(index, 1, item);
      this.data.valores = values;
    }

    this.loader.stop();
    this.closeValueForm();
  }

  public toggleItemStatus(item: any, status: boolean): void {
    this.loader.start('Atualizando registro...');
    item.ativo = status;
    this.loader.stop();
  }

  public newItemValue(): void {
    this.formOpen = true;
    this.formIsEdit = false;
    this.item = {};
  }

  public closeValueForm(): void {
    this.item = {};
    this.formOpen = false;
  }

  public onClose(): void {
    this.$emit('close');
  }
}
